export async function showProcess() {
    try{
        var element = await document.getElementsByClassName('App-process')[0];
        await element.classList.add("App-process-visible");
    }catch(e){

    }
}

export async function hideProcess() {
    try{
        var element = await document.getElementsByClassName('App-process')[0];
        await element.classList.remove("App-process-visible");
    }catch(e){

    }
}

export function isHole(perfil) {
    try{
        return JSON.parse(localStorage.getItem("usuario"))['usuarioPerfis'].filter(up => up.id.perfil === perfil).length > 0;
    }catch(e){
        return false;
    }
    
}


export function filiaisForUser(perfil) {
    try{

        var filiais = [];

        JSON.parse(localStorage.getItem("usuario"))['usuarioFiliais'].forEach(f => filiais.push(f.id.filial))

        return filiais;

    }catch(e){
        return [];
    }
    
}
